import {
  Component,
  OnInit,
  ChangeDetectorRef
} from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { FormControl } from "@angular/forms";
import { NotificationsService } from "angular2-notifications";
import {
  SelectionLists,
  CurrentSelection,
  Equipment,
  Customer,
  JobSite,
  Model,
  Make
} from "../../entities";
import { AppService } from "../../app.service";
import { TranslateService } from "../../translate";
import { LoadingService } from "../../shared/services/loading.service";
//import { ENTER, COMMA } from "@angular/cdk/keycodes";
import {
  InventorySearchItems,
  SystemsInInventoryViewModel,
  SystemComponentViewModel
} from "../inventory/inventory-models";
import { InventoryService } from "../inventory/inventory-service.service";
import { SystemInventoryManagementComponent } from "../inventory/inventory-management/system-inventory-management/system-inventory-management.component";
import { WsreCreateNewInspectionComponent } from "../inventory/inventory-management/wsre-create-new-inspection/wsre-create-new-inspection.component";
import { ActivatedRoute } from '@angular/router';
import { FavouriteDialogService } from "../GET_NEW_UI/favourite-dialog/favourite-dialog.service";
import { EquipmentSelectItem } from "../GET_NEW_UI/setup-equipment/setup-equipment.model";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

export interface System {
  Id: number;
  SerialNumber: string;
  JobSiteId: number;
}

@Component({
  selector: 'app-wsre-search-on-equipment',
  templateUrl: './wsre-search-on-equipment.component.html',
  styleUrls: ['./wsre-search-on-equipment.component.scss'],
  providers: [InventoryService]
})
export class WsreSearchOnEquipmentComponent implements OnInit {
  translateSubscription: Subscription;
  userLanguage = "english";
  _loading = 0;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = "";
  _selectedEquipment: Equipment = new Equipment();
  //separatorKeysCodes = [ENTER, COMMA];

  items: SystemsInInventoryViewModel[] = [];
  inventorySearchFilter: InventorySearchItems = new InventorySearchItems(2000); // todo : should implement paged table

  equipmentCtrl: FormControl;

  filteredSystems: SystemsInInventoryViewModel[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  selectedCustomer: Customer;
  isLoading = false;
  selectedJobsite: JobSite;
  selectedMake: Make;
  selectedModel: Model;
  selectedEq: number;

  private _listFilter: string;

  totalcount = 0;
  avaragecmu = 0;
  chainId: number;
  jobSiteID: number;
  componenetsdetails: SystemComponentViewModel[];

  SystemId: number;

  public get listFilter(): string {
    return this._listFilter;
  }
  public set listFilter(v: string) {
    this._listFilter = v;
    this.filteredSystems = this.listFilter
      ? this.performFilter(this.listFilter)
      : this.items;
  }

  performFilter(filter: string): SystemsInInventoryViewModel[] {
    filter = filter.toLowerCase();
    return this.items.filter(s => {
      // tslint:disable-next-line:no-unused-expression
      return s.SerialNumber.toLowerCase().indexOf(filter) !== -1;
    });
  }

  constructor(
    private _appService: AppService,
    private _translate: TranslateService,
    public snackBar: MatSnackBar,
    private _notification: NotificationsService,
    private _loadingService: LoadingService,
    private inventoryService: InventoryService,
    private _dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private _router: ActivatedRoute,
    public _favouriteDialogService: FavouriteDialogService,

  ) { }
  ngOnInit() {
    this.SystemId = this._router.snapshot.params.id;
    // this.chainId = this._router.snapshot.params.id
    // this.jobSiteID = this._router.snapshot.params.jobsiteId

    // if(this.chainId && this.jobSiteID){

    // }

    // console.log("chainId",this.chainId)


    this._appService.setPageTitle("Inventory");
    this._loading++;
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getMakeListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.makeList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getModelListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.modelList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );

    this._appService.getModelListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.modelList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );

    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }


  isWSREEnable: boolean = false;
  arrSystems: System[];

  private search() {
    this._loadingService.startLoading();
    this.isLoading = true;

    this.inventorySearchFilter.EquipmentID = this.selectedEq
    this.inventoryService
      .searchSystemInEquipment(this.inventorySearchFilter)
      .subscribe(
        r => {
          this.items = r.ListSystemInventory;
          let _filteredSystems = r.ListSystemInventory.filter(f => f.SystemType == this.SystemId);

          //TT-2355
          console.log("filteredSystems", r)
          //check site enable for WSRE
          this.isWSREEnable = r.isWSREEnable;


          if (_filteredSystems.length > 0) {
            let arr_ = []

            let promiseSystems = _filteredSystems.map(async systems => {
              let obj_ = {}

              obj_["Id"] = systems.SystemId
              obj_["SerialNumber"] = systems.SerialNumber
              obj_["JobSiteId"] = systems.JobSiteId

              arr_.push(obj_)

              let response = await this.inventoryService
                .getSystemComponentsInfo(systems.SystemId).toPromise();
              systems.Components = response;


              return systems;

            });
            Promise.all(promiseSystems).then((res) => {
              console.log("Promise", res)
              this.filteredSystems = res
              this.filteredSystems.map(systems => {
                let totalCMU = 0;
                systems.Components.forEach(comp => {
                  this.totalcount = systems.Components.length;
                  totalCMU = comp.CMU + totalCMU;
                });

                this.avaragecmu = parseFloat((totalCMU / this.totalcount).toFixed(2));
                systems.AverageCMU = this.avaragecmu;

              })

              this.filteredSystems = res
              this.finishedLoading();
            })

            this.arrSystems = arr_

          } else {
            this.finishedLoading();
          }


        },
        error => {
          this.finishedLoading();
        }
      );
  }

  finishedLoading() {
    this._loadingService.finishedLoading();
    this.isLoading = false;
  }

  customerChanged(event: any): void {
    this.selectedCustomer = event.value;
    if (!this.selectedCustomer) {
      return;
    }
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === this.selectedCustomer.Id
    );
    this.inventorySearchFilter.CustomerId = this.selectedCustomer.Id;
    this.inventorySearchFilter.JobsiteId = 0;
    this.selectedJobsite = null;
    //this.resetModel();
    //this.resetMake();
    //this.search();
  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    this.inventorySearchFilter.JobsiteId = this.selectedJobsite.Id;

    var params: number[] = [];
    params[0] = this.selectedJobsite.Id

    this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
      console.log("_favouriteDialogService", r)
      if (r) {
        this.equipmentList = r;
      }
    });

    //this.resetModel();
    //this.resetMake();
    //this.search();
  }

  equipmentChanged(event) {
    this.search();
  }

  makeChanged(event) {
    this.selectedMake = event.value;
    if (!this.selectedMake) {
      return;
    }
    this.inventorySearchFilter.MakeId = this.selectedMake.Id;
    console.log(this._dropDownLists.modelList);
    console.log(this.selectedMake);
    this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
      m => m.MakeId === this.selectedMake.Id
    );
    this.search();
  }

  modelChanged(event) {
    this.selectedModel = event.value;
    if (!this.selectedModel) {
      return;
    }
    this.inventorySearchFilter.ModelId = this.selectedModel.Id;
    this.search();
  }

  resetMake() {
    this.inventorySearchFilter.MakeId = 0;
    this.selectedMake = null;
    this._dropDownListsFiltered.makeList = this._dropDownLists.makeList;
  }

  resetModel() {
    this.inventorySearchFilter.ModelId = 0;
    this.selectedModel = null;
    this._dropDownListsFiltered.modelList = this._dropDownLists.modelList;
  }

  openSelcetionDilaog(item) {


    this.onClickStartInspection(item)
    // const dialogRef = this._dialog.open(InventoryOrWsreDialogComponent, {
    //   panelClass: "removeModalOverflowTest",
    //   data: {

    //   },
    //   disableClose: true
    // });

    // dialogRef.afterClosed().subscribe(changed => {
    //   if (changed==0) {
    //   }else if(changed==1){
    //     this.open(item);
    //   }else if(changed==2){
    //     this.onClickStartInspection(item)
    //   }
    // });
  }

  open(item) {
    const dialogRef = this._dialog.open(SystemInventoryManagementComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        system: item,
        customer: this.selectedCustomer,
        customers: this._dropDownLists.customerList,
        jobsites: this._dropDownLists.jobSiteList
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        this.search();
      }
    });
  }

  onClickStartInspection(item) {

    if (item == null) {
      return
    }

    let filSystems = this.filteredSystems != null ? this.filteredSystems.find(f => f.SystemId == item.SystemId) : null
    let filteredIdlers =item.SystemType ==2?  filSystems != null && filSystems.Components != null ? filSystems.Components.filter(f => f.CompartId == 17) :[]: filSystems.Components 

    const dialogRef = this._dialog.open(WsreCreateNewInspectionComponent, {
      panelClass: "removeModalOverflowTest",
      data: {
        systemId: item.SystemType,
        system: item,
        customer: this.selectedCustomer,
        customers: this._dropDownLists.customerList,
        jobsites: this._dropDownLists.jobSiteList,
        systemList: this.arrSystems,
        componentList: filteredIdlers
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {

      }
    });
  }
}

